import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid,
  Button,
  Card,
  CardContent,
  CardMedia,
  CardActions,
  TextField,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Switch,
  FormControlLabel,
  IconButton
} from '@mui/material';
import {
  ShoppingCart as ShoppingCartIcon,
  Favorite as FavoriteIcon,
  Star as StarIcon,
  Settings as SettingsIcon,
  Home as HomeIcon
} from '@mui/icons-material';
import { useStoreSettings } from '../../contexts/StoreSettingsContext';

const ThemeDemo: React.FC = () => {
  const { settings } = useStoreSettings();
  const activeTheme = settings?.display?.theme || 'default';

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3, mb: 4 }}>
        <Typography variant="h4" gutterBottom>
          معاينة الثيم: {activeTheme}
        </Typography>
        <Typography variant="body1" paragraph>
          هذه الصفحة تعرض مكونات واجهة المستخدم المختلفة لمعاينة كيفية تطبيق الثيم الحالي عليها.
        </Typography>
        <Divider sx={{ my: 2 }} />

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Typography variant="h6" gutterBottom>
              الأزرار
            </Typography>
            <Box sx={{ '& > button': { m: 1 } }}>
              <Button variant="contained" color="primary">
                زر أساسي
              </Button>
              <Button variant="contained" color="secondary">
                زر ثانوي
              </Button>
              <Button variant="outlined" color="primary">
                زر محدد
              </Button>
              <Button variant="text" color="primary">
                زر نصي
              </Button>
              <Button
                variant="contained"
                color="primary"
                startIcon={<ShoppingCartIcon />}
              >
                أضف للسلة
              </Button>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="h6" gutterBottom>
              حقول الإدخال
            </Typography>
            <Box sx={{ '& > *': { mb: 2 } }}>
              <TextField
                fullWidth
                label="حقل نصي"
                variant="outlined"
                placeholder="أدخل نصًا هنا"
              />
              <TextField
                fullWidth
                label="حقل رقمي"
                type="number"
                variant="outlined"
              />
              <FormControlLabel
                control={<Switch color="primary" />}
                label="مفتاح تبديل"
              />
            </Box>
          </Grid>
        </Grid>
      </Paper>

      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <Typography variant="h5" gutterBottom>
            بطاقات المنتجات
          </Typography>
          <Grid container spacing={2}>
            {[1, 2, 3, 4].map((item) => (
              <Grid item xs={12} sm={6} key={item}>
                <Card className="product-card">
                  <CardMedia
                    component="img"
                    height="140"
                    image={`https://source.unsplash.com/random/300x200?product=${item}`}
                    alt={`منتج ${item}`}
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h6" component="div">
                      منتج تجريبي {item}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      هذا وصف تجريبي للمنتج. يمكن أن يحتوي على معلومات عن المنتج وخصائصه.
                    </Typography>
                    <Typography variant="h6" color="primary" sx={{ mt: 2 }}>
                      {(item * 100).toLocaleString('ar-EG')} ج.م
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button
                      size="small"
                      variant="contained"
                      color="primary"
                      startIcon={<ShoppingCartIcon />}
                    >
                      أضف للسلة
                    </Button>
                    <Button
                      size="small"
                      variant="outlined"
                      startIcon={<FavoriteIcon />}
                    >
                      المفضلة
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>

        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2, mb: 3 }} className="store-header">
            <Typography variant="h6" gutterBottom color="white">
              رأس الصفحة
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button color="inherit">الرئيسية</Button>
              <Button color="inherit">المنتجات</Button>
              <Button color="inherit">العروض</Button>
            </Box>
          </Paper>

          <Paper sx={{ p: 2, mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              قائمة التصنيفات
            </Typography>
            <List>
              {['الإلكترونيات', 'الملابس', 'الأثاث', 'مستلزمات المنزل'].map((text, index) => (
                <ListItem key={text} button={true}>
                  <ListItemIcon>
                    {index % 2 === 0 ? <StarIcon /> : <SettingsIcon />}
                  </ListItemIcon>
                  <ListItemText primary={text} />
                </ListItem>
              ))}
            </List>
          </Paper>

          <Paper sx={{ p: 2 }} className="store-footer">
            <Typography variant="h6" gutterBottom>
              تذييل الصفحة
            </Typography>
            <Typography variant="body2">
              © {new Date().getFullYear()} اليكترونيات السواح. جميع الحقوق محفوظة.
            </Typography>
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
              <IconButton color="inherit" size="small">
                <HomeIcon />
              </IconButton>
              <IconButton color="inherit" size="small">
                <ShoppingCartIcon />
              </IconButton>
              <IconButton color="inherit" size="small">
                <FavoriteIcon />
              </IconButton>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ThemeDemo;
